import Link from 'next/link'
import { useState } from 'react'
import { Image } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import PDFView from './modals/PDFView'
import DocumentText from '../svgs/DocumentText'

const imageTypes = ['png', 'jpeg', 'jpg', 'tiff', 'svg']
const txtTypes = ['pdf']

const FileTabLink = ({ fileLink, filename, index, fz, withIcon }) => {
  const { t } = useTranslation()

  const [pdfOpen, setPdfOpen] = useState(false)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <div className='flex items-center gap-8'>
        {withIcon ? <DocumentText style='w-20' /> : null}
        <Link
          href={fileLink}
          target='_blank'
          rel='noreferrer'
          className={`!text-green !underline ${fz || 'text-sm'} font-medium`}
          onClick={(event) => {
            event.preventDefault()
            const fileType = fileLink.split('.').slice(-1)[0]

            if (txtTypes.includes(fileType)) {
              setPdfOpen(true)
            } else if (imageTypes.includes(fileType)) {
              setVisible(true)
            } else {
              window.open(fileLink, '_blank')
            }
          }}
        >
          {filename || `${t('Document')} ${index + 1}`}
        </Link>
      </div>

      <PDFView open={pdfOpen} setOpen={setPdfOpen} link={fileLink} />

      {visible ? (
        <Image
          className='image-link'
          width={0}
          style={{ display: 'none' }}
          src={fileLink}
          alt={fileLink}
          preview={{
            visible,
            onVisibleChange: (value) => {
              setVisible(value)
            },
          }}
        />
      ) : null}
    </>
  )
}

export default FileTabLink
